import React from "react";
import { C } from "../constants";
import Btn from "./Btn";

/**
 * Reminder shown when a problem statement already exists.
 * It never blocks: the user can plan the same problem or choose a new one.
 */
export default function DuplicateStatementNotice({
  matches = [],
  busy = false,
  onUseSame,
  onChooseDifferent,
  onDismiss,
}) {
  if (!matches.length) return null;
  const mine = matches.filter((m) => m.isMine);
  const others = matches.filter((m) => !m.isMine);

  return (
    <div
      role="alert"
      style={{
        margin: "10px 0",
        padding: "12px 14px",
        border: "1px solid #FCD34D",
        background: "#FFFBEB",
        borderRadius: 10,
        color: C.text,
        fontSize: 13,
        lineHeight: 1.5,
      }}
    >
      <div style={{ display: "flex", gap: 8, alignItems: "center", fontWeight: 800, marginBottom: 4 }}>
        <i className="ti ti-bell-ringing" style={{ fontSize: 17, color: "#B45309" }} />
        This problem statement already exists
      </div>
      <p style={{ margin: "0 0 8px", color: C.muted, fontSize: 12.5 }}>
        This is a reminder, not a block. You can still create your own plan for this same problem,
        or choose a new one.
      </p>

      {mine.length > 0 && (
        <p style={{ margin: "0 0 8px", fontWeight: 650 }}>
          You already have this statement
          {mine[0].teamName ? ` (team ${mine[0].teamName})` : ""}.
        </p>
      )}

      {others.length > 0 && (
        <div style={{ overflowX: "auto", marginBottom: 10 }}>
          <div style={{ fontSize: 11.5, fontWeight: 750, color: C.muted, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.04em" }}>
            Who has this plan
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12.5, background: "#fff", border: `1px solid ${C.border}` }}>
            <thead>
              <tr style={{ background: "#F8FAFC", textAlign: "left" }}>
                {["Name", "Department", "Year", "Team", "Match"].map((h) => (
                  <th key={h} style={{ padding: "6px 10px", fontSize: 11, color: C.muted, borderBottom: `1px solid ${C.border}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {others.map((m) => (
                <tr key={m.statementId} style={{ borderBottom: `1px solid ${C.border}` }}>
                  <td style={{ padding: "6px 10px", fontWeight: 700 }}>
                    {m.owner?.name || "—"}
                    {m.owner?.registerNumber ? (
                      <span style={{ color: C.muted, fontWeight: 500 }}> · {m.owner.registerNumber}</span>
                    ) : null}
                  </td>
                  <td style={{ padding: "6px 10px" }}>{m.owner?.department || "—"}</td>
                  <td style={{ padding: "6px 10px" }}>
                    {m.owner?.year || (m.createdYear ? `Created ${m.createdYear}` : "—")}
                  </td>
                  <td style={{ padding: "6px 10px" }}>
                    {m.teamName || "—"}
                    {m.members?.length > 1 ? ` (${m.members.length} members)` : ""}
                  </td>
                  <td style={{ padding: "6px 10px" }}>{m.exact ? "Exact" : "Very similar"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <Btn small variant="primary" disabled={busy} onClick={onUseSame}>
          {busy ? "Saving…" : "Create my plan for this same problem"}
        </Btn>
        <Btn small variant="outline" disabled={busy} onClick={onChooseDifferent}>
          Choose a different problem
        </Btn>
        {onDismiss && (
          <Btn small variant="outline" disabled={busy} onClick={onDismiss}>
            Dismiss
          </Btn>
        )}
      </div>
    </div>
  );
}
